var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegister(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "728px",
    height: "591px",
    viewBox: "0 0 728 591",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-9.8%",
    y: "-9.8%",
    width: "119.7%",
    height: "119.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "68.6694733%",
    y1: "-81.3893331%",
    x2: "68.6694733%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2FFEA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CA5FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.388768,0 L151.480514,0 C154.456648,3.41471402e-16 156.869282,2.41263361 156.869282,5.388768 L156.869282,52.8997392 C156.869282,55.8758736 154.456648,58.2885072 151.480514,58.2885072 L5.388768,58.2885072 C2.41263361,58.2885072 -5.23707075e-16,55.8758736 0,52.8997392 L0,5.388768 C5.23707075e-16,2.41263361 2.41263361,2.32306386e-15 5.388768,0 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-22.0%",
    y: "-57.5%",
    width: "152.9%",
    height: "242.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 7,
    dy: 8,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0755212756   0 0 0 0 0.582569014   0 0 0 0 0.878793025  0 0 0 0.229458042 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.50398247   0 0 0 0 0.700178215   0 0 0 0 1  0 0 0 0.233828671 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M8,0 L148.476667,0 C152.894945,-1.65085012e-14 156.476667,3.581722 156.476667,8 L156.476667,124.215082 C156.476667,128.63336 152.894945,132.215082 148.476667,132.215082 L8,132.215082 C3.581722,132.215082 5.41083001e-16,128.63336 0,124.215082 L0,8 C-5.41083001e-16,3.581722 3.581722,8.11624501e-16 8,0 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-24.6%",
    y: "-28.4%",
    width: "159.4%",
    height: "170.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-7"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 9,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0755212756   0 0 0 0 0.582569014   0 0 0 0 0.878793025  0 0 0 0.229458042 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.50398247   0 0 0 0 0.700178215   0 0 0 0 1  0 0 0 0.233828671 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M20.9333333,101.167213 C33.3072193,97.6140224 42.2221433,92.2112006 47.6781053,84.9587477 C55.8620484,74.0800684 58.6211293,63.5355205 72.6967097,63.5355205 C86.7722901,63.5355205 88.5769653,79.6852138 103.793002,79.6852138 C119.009039,79.6852138 119.841169,59.0900141 124.898413,50.9122201 C128.269909,45.4603575 132.864883,42.7344262 138.683333,42.7344262",
    id: "path-8"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-12.9%",
    y: "-15.1%",
    width: "125.4%",
    height: "151.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-9"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.32,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 6,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.32,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 6,
    in: "shadowInner",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetOuter1",
    in2: "shadowInner",
    operator: "out",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.144394668 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "42.3142644%",
    y1: "-3.80155206%",
    x2: "50%",
    y2: "78.24779%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2B2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "43.4874564%",
    y1: "-28.1859254%",
    x2: "50%",
    y2: "91.0504812%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2B2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "45.2488919%",
    y1: "-28.1859254%",
    x2: "61.7385065%",
    y2: "121.546626%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAFAF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F07777",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "31.7132608%",
    y1: "-6.14532105%",
    x2: "55.1442779%",
    y2: "90.676284%",
    id: "linearGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2B2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "42.3142644%",
    y1: "8.58120408%",
    x2: "50%",
    y2: "71.7463884%",
    id: "linearGradient-14"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2B2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "42.3142644%",
    y1: "22.4182939%",
    x2: "50%",
    y2: "64.4814083%",
    id: "linearGradient-15"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2B2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "107.85141%",
    y1: "60.7630114%",
    x2: "13.8345679%",
    y2: "60.7630114%",
    id: "linearGradient-16"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16B79",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69D88",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "68.6694733%",
    y1: "-22.7541031%",
    x2: "68.6694733%",
    y2: "100%",
    id: "linearGradient-17"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FF6EC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D9DFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.90624038,0 L36.5106644,0 C36.9083094,-2.9509081e-16 37.2306644,0.32235498 37.2306644,0.72 C37.2306644,0.77036697 37.2253794,0.82059492 37.2148961,0.869858835 L29.6379913,36.4760127 C29.5672473,36.8084605 29.2736512,37.0461538 28.9337596,37.0461538 L1.32933562,37.0461538 C0.931690599,37.0461538 0.609335619,36.7237989 0.609335619,36.3261538 C0.609335619,36.2757869 0.614620645,36.2255589 0.625103889,36.176295 L8.20200865,0.570141165 C8.27275275,0.237693377 8.56634884,9.50615483e-16 8.90624038,0 Z",
    id: "path-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "45.0695896%",
    y1: "-28.1859254%",
    x2: "62.1815065%",
    y2: "121.546626%",
    id: "linearGradient-20"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAFAF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F07777",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "31.7132608%",
    y1: "-5.45002967%",
    x2: "55.1442779%",
    y2: "90.1725577%",
    id: "linearGradient-21"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2B2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "44.2057661%",
    y1: "-12.849681%",
    x2: "51.6299871%",
    y2: "95.5334732%",
    id: "linearGradient-22"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2B2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "44.6933292%",
    y1: "-28.1859254%",
    x2: "50%",
    y2: "91.0504812%",
    id: "linearGradient-23"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2B2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "45.9630404%",
    y1: "-28.1859254%",
    x2: "50%",
    y2: "91.0504812%",
    id: "linearGradient-24"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2B2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "31.7132608%",
    y1: "31.5572511%",
    x2: "55.1442779%",
    y2: "63.3614428%",
    id: "linearGradient-25"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2B2",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDCDD-Pages-New",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Register",
    transform: "translate(-114.000000, -238.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(114.000000, 251.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M558.524599,155.012318 L686.342912,155.169384 C691.85616,155.176159 696.323841,159.64384 696.330616,165.157088 L696.487682,292.975401 C696.494468,298.498244 692.022821,302.980895 686.499977,302.987682 C686.491785,302.987692 686.483593,302.987692 686.475401,302.987682 L558.657088,302.830616 C553.14384,302.823841 548.676159,298.35616 548.669384,292.842912 L548.512318,165.024599 C548.505532,159.501756 552.977179,155.019105 558.500023,155.012318 C558.508215,155.012308 558.516407,155.012308 558.524599,155.012318 Z",
    id: "Rectangle",
    fill: "#BFE7FF",
    opacity: 0.150018601,
    transform: "translate(622.500000, 229.000000) rotate(-45.000000) translate(-622.500000, -229.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.807146,19.4230043 L309.025482,19.5105186 C314.53873,19.5172933 319.006411,23.9849747 319.013186,29.4982229 L319.1007,100.716559 C319.107487,106.239402 314.635839,110.722053 309.112996,110.72884 C309.104804,110.72885 309.096612,110.72885 309.08842,110.72884 L237.870083,110.641325 C232.356835,110.63455 227.889154,106.166869 227.882379,100.653621 L227.794865,29.4352849 C227.788078,23.9124415 232.259726,19.4297908 237.782569,19.4230043 C237.790761,19.4229942 237.798953,19.4229942 237.807146,19.4230043 Z",
    id: "Rectangle",
    fill: "#7367F0",
    opacity: 0.0375744048,
    filter: "url(#filter-1)",
    transform: "translate(273.447783, 65.075922) rotate(-45.000000) translate(-273.447783, -65.075922) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.588761,91.1063585 L596.189125,91.4327328 C601.702373,91.4395075 606.170054,95.9071889 606.176829,101.420437 L606.503203,367.0208 C606.50999,372.543643 602.038342,377.026294 596.515499,377.033081 C596.507307,377.033091 596.499115,377.033091 596.490923,377.033081 L330.890559,376.706706 C325.377311,376.699932 320.90963,372.23225 320.902855,366.719002 L320.576481,101.118639 C320.569694,95.5957958 325.041342,91.113145 330.564185,91.1063585 C330.572377,91.1063484 330.580569,91.1063484 330.588761,91.1063585 Z",
    id: "Rectangle",
    fill: "#7367F0",
    opacity: 0.0659412202,
    transform: "translate(463.539842, 234.069720) rotate(-45.000000) translate(-463.539842, -234.069720) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.715308,269.000314 C226.72012,269.000314 231.587983,273.856228 231.587983,279.846301 L231.587983,449.043698 C231.587983,455.033772 226.72012,459.889685 220.715308,459.889685 L51.1015737,459.889685 C45.0967609,459.889685 40.2288984,455.033772 40.2288984,449.043698 L40.2288984,279.846301 C40.2288984,273.856228 45.0967609,269.000314 51.1015737,269.000314 L220.715308,269.000314 Z M188.097282,312.383948 L83.7195994,312.383948 L83.7195994,416.505423 L188.097282,416.505423 L188.097282,312.383948 Z",
    id: "Rectangle",
    fill: "#7367F0",
    fillRule: "nonzero",
    opacity: 0.0895647321,
    transform: "translate(135.908441, 364.445000) rotate(-45.000000) translate(-135.908441, -364.445000) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Office-Desk",
    transform: "translate(103.000000, 140.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(8.500000, 203.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-2)",
    points: "89.7928662 0 89.7924403 143.767423 89.9387788 143.625423 89.9045094 150.756949 172.573172 232.951321 161.553489 232.951321 89.7924403 161.56666 89.7928662 232.911628 81.0884637 232.911628 81.0880377 164.288679 12.1077337 232.951321 -4.94787998e-13 232.951321 81.0880377 152.307879 81.0884637 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8557593,140.4 L101.113621,140.4 C103.875045,140.4 106.113621,142.638576 106.113621,145.4 L106.113621,152.813953 C106.113621,155.575377 103.875045,157.813953 101.113621,157.813953 L70.8557593,157.813953 C68.0943356,157.813953 65.8557593,155.575377 65.8557593,152.813953 L65.8557593,145.4 C65.8557593,142.638576 68.0943356,140.4 70.8557593,140.4 Z",
    id: "Rectangle",
    fill: "#C8DAFF",
    transform: "translate(85.984690, 149.106977) scale(-1, 1) translate(-85.984690, -149.106977) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mini-Board",
    transform: "translate(13.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7499354,0 L165.301105,0 C168.154296,0 170.467265,2.30415222 170.467265,5.14646802 L170.467265,259.600129 C170.467265,262.363492 168.28101,264.618174 165.537582,264.741302 L165.281025,264.746558 L165.281025,264.746558 L12.7298556,264.155879 C9.8845239,264.144862 7.58377486,261.843957 7.58377486,259.00945 L7.58377486,5.14646802 C7.58377486,2.30415222 9.8967437,0 12.7499354,0 Z",
    id: "Rectangle",
    fill: "#AFA7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.27821562,0 L157.829385,0 C160.682577,0 162.995546,2.30415222 162.995546,5.14646802 L162.995546,259.600129 C162.995546,262.363492 160.80929,264.618174 158.065863,264.741302 L157.809305,264.746558 L157.809305,264.746558 L5.25813581,264.155879 C2.41280416,264.144862 0.112055113,261.843957 0.112055113,259.00945 L0.112055113,5.14646802 C0.112055113,2.30415222 2.42502396,0 5.27821562,0 Z",
    id: "Rectangle",
    fill: "#D5D1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6411704,5.31659919 L150.25539,5.31659919 C153.519441,5.31659919 156.165478,7.95254932 156.165478,11.2041586 L156.165478,251.435841 C156.165478,254.687451 153.519441,257.323401 150.25539,257.323401 L12.6411704,257.323401 C9.37711916,257.323401 6.7310828,254.687451 6.7310828,251.435841 L6.7310828,11.2041586 C6.7310828,7.95254932 9.37711916,5.31659919 12.6411704,5.31659919 Z",
    id: "Rectangle",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8309554,249.880162 L97.4591083,249.880162 C99.8171179,249.880162 101.728662,251.78442 101.728662,254.133441 L101.728662,267.956599 L55.8309554,267.956599 C53.4729458,267.956599 51.5614013,266.052341 51.5614013,263.70332 L51.5614013,254.133441 C51.5614013,251.78442 53.4729458,249.880162 55.8309554,249.880162 Z",
    id: "Rectangle",
    fill: "#A7C3FF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#A7C3FF",
    points: "100.661274 263.70332 104.930828 263.70332 104.930828 267.956599 100.661274 267.956599"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6961783,249.880162 L95.3243312,249.880162 C97.6823409,249.880162 99.5938854,251.78442 99.5938854,254.133441 L99.5938854,263.70332 C99.5938854,266.052341 97.6823409,267.956599 95.3243312,267.956599 L53.6961783,267.956599 C51.3381687,267.956599 49.4266242,266.052341 49.4266242,263.70332 L49.4266242,254.133441 C49.4266242,251.78442 51.3381687,249.880162 53.6961783,249.880162 Z",
    id: "Rectangle",
    fill: "#C8DAFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-61",
    transform: "translate(241.500000, 31.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#91D6FF",
    x: 5.27168955,
    y: 0,
    width: 67.6533493,
    height: 77.7504
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E3F4FF",
    x: 0,
    y: 0,
    width: 67.6533493,
    height: 77.7504
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9075343,9.1728 L55.7458149,9.1728 C57.9549539,9.1728 59.7458149,10.963661 59.7458149,13.1728 L59.7458149,65.0144 C59.7458149,67.223539 57.9549539,69.0144 55.7458149,69.0144 L11.9075343,69.0144 C9.69839533,69.0144 7.90753433,67.223539 7.90753433,65.0144 L7.90753433,13.1728 C7.90753433,10.963661 9.69839533,9.1728 11.9075343,9.1728 Z",
    id: "Rectangle",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9075343,9.1728 L13.1792239,9.1728 L13.1792239,9.1728 L13.1792239,69.0144 L11.9075343,69.0144 C9.69839533,69.0144 7.90753433,67.223539 7.90753433,65.0144 L7.90753433,13.1728 C7.90753433,10.963661 9.69839533,9.1728 11.9075343,9.1728 Z",
    id: "Rectangle",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6130761,52.2751683 L33.3050915,22.1176427 C33.1942483,21.9245088 32.9478261,21.8577991 32.7546923,21.9686423 C32.6905804,22.0054374 32.6378175,22.0591491 32.6021708,22.1239065 L16.0015183,52.2814321 C15.8941345,52.4765106 15.9652251,52.7217048 16.1603036,52.8290887 C16.2198651,52.8618751 16.2867502,52.8790678 16.3547393,52.8790678 L50.2633763,52.8790678 C50.4860575,52.8790678 50.6665763,52.698549 50.6665763,52.4758678 C50.6665763,52.4054437 50.6481309,52.3362479 50.6130761,52.2751683 Z",
    id: "Path-127",
    fill: "#83F2D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7894527,40.529368 L43.4046391,24.279456 C43.2932724,24.0866234 43.0466703,24.0205822 42.8538377,24.1319489 C42.7904621,24.1685502 42.7382436,24.2217108 42.7027812,24.2857307 L33.7015003,40.5356427 C33.5935991,40.7304356 33.6640387,40.9758176 33.8588316,41.0837188 C33.9186228,41.1168388 33.9858524,41.1342151 34.054204,41.1342151 L52.4402985,41.1342151 C52.6629797,41.1342151 52.8434985,40.9536964 52.8434985,40.7310151 C52.8434985,40.6602203 52.8248584,40.5906734 52.7894527,40.529368 Z",
    id: "Path-127",
    fill: "#63CBE8",
    opacity: 0.44687035
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-61",
    transform: "translate(338.500000, 31.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#91D6FF",
    x: 5.27168955,
    y: 0,
    width: 67.6533493,
    height: 77.7504
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E3F4FF",
    x: 0,
    y: 0,
    width: 67.6533493,
    height: 77.7504
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9075343,9.1728 L55.7458149,9.1728 C57.9549539,9.1728 59.7458149,10.963661 59.7458149,13.1728 L59.7458149,65.0144 C59.7458149,67.223539 57.9549539,69.0144 55.7458149,69.0144 L11.9075343,69.0144 C9.69839533,69.0144 7.90753433,67.223539 7.90753433,65.0144 L7.90753433,13.1728 C7.90753433,10.963661 9.69839533,9.1728 11.9075343,9.1728 Z",
    id: "Rectangle",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#83F2D5",
    x: 20.2081433,
    y: 28.8288,
    width: 25.9191403,
    height: 25.7712
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#63CBE8",
    opacity: 0.44687035,
    x: 34.2659821,
    y: 18.7824,
    width: 19.7688358,
    height: 19.656
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9075343,9.1728 L13.1792239,9.1728 L13.1792239,9.1728 L13.1792239,69.0144 L11.9075343,69.0144 C9.69839533,69.0144 7.90753433,67.223539 7.90753433,65.0144 L7.90753433,13.1728 C7.90753433,10.963661 9.69839533,9.1728 11.9075343,9.1728 Z",
    id: "Rectangle",
    fill: "#91D6FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-61",
    transform: "translate(434.500000, 31.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#91D6FF",
    x: 5.27168955,
    y: 0,
    width: 67.6533493,
    height: 77.7504
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E3F4FF",
    x: 0,
    y: 0,
    width: 67.6533493,
    height: 77.7504
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9075343,9.1728 L55.7458149,9.1728 C57.9549539,9.1728 59.7458149,10.963661 59.7458149,13.1728 L59.7458149,65.0144 C59.7458149,67.223539 57.9549539,69.0144 55.7458149,69.0144 L11.9075343,69.0144 C9.69839533,69.0144 7.90753433,67.223539 7.90753433,65.0144 L7.90753433,13.1728 C7.90753433,10.963661 9.69839533,9.1728 11.9075343,9.1728 Z",
    id: "Rectangle",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#83F2D5",
    cx: 34.4856358,
    cy: 41.7144,
    rx: 18.2312597,
    ry: 18.1272
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#63CBE8",
    opacity: 0.44687035,
    cx: 43.2717851,
    cy: 27.3,
    rx: 9.44511045,
    ry: 9.3912
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9075343,9.1728 L13.1792239,9.1728 L13.1792239,9.1728 L13.1792239,69.0144 L11.9075343,69.0144 C9.69839533,69.0144 7.90753433,67.223539 7.90753433,65.0144 L7.90753433,13.1728 C7.90753433,10.963661 9.69839533,9.1728 11.9075343,9.1728 Z",
    id: "Rectangle",
    fill: "#91D6FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ElementCard25",
    transform: "translate(0.500000, 170.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.8810282,32.382504 L82.2498138,32.382504 C83.2253245,32.382504 84.0161322,33.1733117 84.0161322,34.1488224 C84.0161322,35.1243331 83.2253245,35.9151408 82.2498138,35.9151408 L52.8810282,35.9151408 C51.9055175,35.9151408 51.1147098,35.1243331 51.1147098,34.1488224 C51.1147098,33.1733117 51.9055175,32.382504 52.8810282,32.382504 Z",
    id: "Rectangle",
    fill: "#FFBF29",
    fillRule: "nonzero",
    opacity: 0.46547154
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8810282,22.3733664 L70.4993058,22.3733664 C71.4748165,22.3733664 72.2656242,23.1641741 72.2656242,24.1396848 C72.2656242,25.1151955 71.4748165,25.9060032 70.4993058,25.9060032 L52.8810282,25.9060032 C51.9055175,25.9060032 51.1147098,25.1151955 51.1147098,24.1396848 C51.1147098,23.1641741 51.9055175,22.3733664 52.8810282,22.3733664 Z",
    id: "Rectangle",
    fill: "#FFBF29",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.842296,22.5346013 C109.346858,21.4249875 110.653501,20.9353647 111.760764,21.4409982 C112.126974,21.6082288 112.439584,21.8723472 112.665708,22.2036592 L112.746386,22.3309928 L117.067197,29.6947097 C117.108315,29.7647852 117.198335,29.788189 117.268262,29.7469834 L117.287203,29.7337078 L117.303832,29.7176188 L119.602924,27.1127466 C120.409081,26.1993703 121.80147,26.1138395 122.712911,26.9217082 C122.772809,26.9747999 122.829756,27.0311004 122.883507,27.0903532 L122.961704,27.1814144 L126.333282,31.3308249 C126.384503,31.3938625 126.47702,31.4033538 126.539924,31.3520241 L126.557531,31.3350273 L126.572081,31.3153393 L131.89769,22.6909629 C132.537989,21.6540527 133.895854,21.3336377 134.930568,21.9752959 C135.090787,22.0746526 135.237459,22.1940902 135.367092,22.3305759 L135.461068,22.4360893 L137.942061,25.4080418 C138.306417,25.8445 138.248716,26.4943155 137.813183,26.8594453 C137.401846,27.2042901 136.800602,27.1718714 136.428126,26.7995234 L136.364854,26.7302939 L133.883862,23.7583413 C133.873787,23.746273 133.861847,23.7359015 133.848495,23.7276218 C133.791011,23.6919741 133.718566,23.7008669 133.671312,23.7448256 L133.646303,23.7753329 L128.320695,32.3997094 C128.191601,32.6087664 128.028571,32.7947489 127.838335,32.9499815 C126.927309,33.6933762 125.602203,33.5862911 124.820357,32.7269397 L124.738711,32.6319922 L121.367132,28.4825817 C121.362083,28.4763677 121.356536,28.4705772 121.350546,28.465268 C121.29991,28.4203864 121.227009,28.4168659 121.173013,28.4521774 L121.143213,28.4780039 L118.844121,31.0828761 C118.690509,31.2569184 118.510446,31.4055708 118.310579,31.5233455 C117.296636,32.120826 116.001057,31.8126995 115.358682,30.8420091 L115.294598,30.7392393 L110.973787,23.3755225 C110.958488,23.349449 110.935545,23.3287318 110.908079,23.3161895 C110.846565,23.2880987 110.775819,23.3060847 110.73448,23.3556695 L110.713515,23.3890964 L106.503815,32.6469067 C106.346907,32.9919732 106.104314,33.2899796 105.800237,33.5130157 L105.683374,33.5930856 L100.692094,36.7820806 C100.213287,37.0879969 99.5776685,36.9470171 99.2724004,36.4671934 C98.9840916,36.0140265 99.0935585,35.4206908 99.5099686,35.098453 L99.5866205,35.0444853 L104.5779,31.8554902 C104.593854,31.8452974 104.607615,31.8321623 104.618503,31.8168699 L104.632596,31.7924116 L108.842296,22.5346013 Z",
    id: "Path",
    fill: "#FFBF29",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFBF29",
    fillRule: "nonzero",
    cx: 29.0825073,
    cy: 29.7330264,
    rx: 12.0442707,
    ry: 12.0698424
  })), /*#__PURE__*/React.createElement("g", {
    id: "ElementCard3",
    transform: "translate(0.500000, 19.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-7)",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.9333333,100.042737 C33.3072193,96.5048909 42.2221433,91.1254014 47.6781053,83.9042686 C55.8620484,73.0725695 58.6211293,62.5735588 72.6967097,62.5735588 C86.7722901,62.5735588 88.5769653,78.6535088 103.793002,78.6535088 C119.009039,78.6535088 119.841169,58.1472505 124.898413,50.0047728 C128.269909,44.5764543 132.864883,41.8622951 138.683333,41.8622951 L138.683333,111.617049 C138.683333,112.58907 137.895354,113.377049 136.923333,113.377049 L22.6933333,113.377049 C21.7213122,113.377049 20.9333333,112.58907 20.9333333,111.617049 L20.9333333,100.042737 L20.9333333,100.042737 Z",
    id: "Path-3",
    fill: "#FFE3B5",
    opacity: 0.414736793,
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path-3",
    strokeLinecap: "round",
    mask: "url(#mask-6)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-9)",
    xlinkHref: "#path-8"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#FFBF29",
    strokeWidth: 2.64,
    xlinkHref: "#path-8"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFBF29",
    fillRule: "nonzero",
    mask: "url(#mask-6)",
    x: 12.2111111,
    y: 13.0819672,
    width: 48.8444444,
    height: 5.23278689
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8275046,26.1639344 L32.2724954,26.1639344 C33.7174896,26.1639344 34.8888889,27.3353337 34.8888889,28.7803279 C34.8888889,30.2253221 33.7174896,31.3967213 32.2724954,31.3967213 L14.8275046,31.3967213 C13.3825104,31.3967213 12.2111111,30.2253221 12.2111111,28.7803279 C12.2111111,27.3353337 13.3825104,26.1639344 14.8275046,26.1639344 Z",
    id: "Rectangle",
    fill: "#FFBF29",
    fillRule: "nonzero",
    opacity: 0.46547154,
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.036111,19.1868852 C127.722114,19.1868852 129.088889,17.8202528 129.088889,16.1344262 C129.088889,14.4485997 127.722114,13.0819672 126.036111,13.0819672 C124.350108,13.0819672 122.983333,14.4485997 122.983333,16.1344262 C122.983333,17.8202528 124.350108,19.1868852 126.036111,19.1868852 Z",
    id: "Oval",
    fill: "#FFFFFF",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.758333,19.1868852 C136.444336,19.1868852 137.811111,17.8202528 137.811111,16.1344262 C137.811111,14.4485997 136.444336,13.0819672 134.758333,13.0819672 C133.072331,13.0819672 131.705556,14.4485997 131.705556,16.1344262 C131.705556,17.8202528 133.072331,19.1868852 134.758333,19.1868852 Z",
    id: "Oval",
    fill: "#FFFFFF",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.480556,19.1868852 C145.166558,19.1868852 146.533333,17.8202528 146.533333,16.1344262 C146.533333,14.4485997 145.166558,13.0819672 143.480556,13.0819672 C141.794553,13.0819672 140.427778,14.4485997 140.427778,16.1344262 C140.427778,17.8202528 141.794553,19.1868852 143.480556,19.1868852 Z",
    id: "Oval",
    fill: "#FFFFFF",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Chair1",
    transform: "translate(328.000000, 337.500000) scale(-1, 1) translate(-328.000000, -337.500000) translate(257.500000, 239.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.020018,182.306488 L73.0455809,180.108066 L73.0455809,180.108066 L85.3196145,180.108066 L125.50701,182.306807 C126.397856,182.355547 127.095231,183.09212 127.095231,183.984298 L127.095231,186.964972 L127.095231,186.964972 L31.4321538,186.964972 L31.4321538,183.983959 C31.4321538,183.091919 32.1293203,182.355409 33.020018,182.306488 Z",
    id: "Rectangle",
    fill: "#BFE7FF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#BFE7FF",
    points: "74.7083077 111.996133 83.8190769 111.996133 83.8190769 180.565193 74.7083077 180.565193"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#91D6FF",
    x: 72.4306154,
    y: 170.965525,
    width: 13.6661538,
    height: 15.9994475
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7152308,106.967735 L89.8121538,106.967735 C90.276073,106.967735 90.6521538,107.343816 90.6521538,107.807735 L90.6521538,115.085177 C90.6521538,115.428289 90.443477,115.736911 90.1250592,115.864722 L85.1085356,117.878329 C85.0090472,117.918264 84.9028342,117.938785 84.7956303,117.938785 L73.7317544,117.938785 C73.6245504,117.938785 73.5183374,117.918264 73.418849,117.878329 L68.4023254,115.864722 C68.0839076,115.736911 67.8752308,115.428289 67.8752308,115.085177 L67.8752308,107.807735 C67.8752308,107.343816 68.2513116,106.967735 68.7152308,106.967735 Z",
    id: "Rectangle",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#91D6FF",
    x: 29.1544615,
    y: 186.964972,
    width: 9.11076923,
    height: 9.14254144
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#91D6FF",
    x: 120.262154,
    y: 186.964972,
    width: 9.11076923,
    height: 9.14254144
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#91D6FF",
    x: 74.7083077,
    y: 186.964972,
    width: 9.11076923,
    height: 9.14254144
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6448024,94.1681768 L132.991813,94.1681768 C137.031242,94.1681768 140.305846,97.442781 140.305846,101.48221 C140.305846,105.521639 137.031242,108.796243 132.991813,108.796243 L75.6448024,108.796243 C71.6053734,108.796243 68.3307692,105.521639 68.3307692,101.48221 C68.3307692,97.442781 71.6053734,94.1681768 75.6448024,94.1681768 Z",
    id: "Rectangle",
    fill: "#BFE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7987692,26.5133702 L45.5538462,26.5133702 C45.5538462,38.7034254 45.5538462,50.8934807 45.5538462,63.0835359 C45.5538462,75.2735912 52.3869231,87.4636464 66.0530769,99.6537017 L49.1981538,99.6537017 C38.2652308,89.2728551 32.7987692,77.0827999 32.7987692,63.0835359 C32.7987692,50.8934807 32.7987692,38.7034254 32.7987692,26.5133702 Z",
    id: "Rectangle",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2652308,26.5133702 L51.0203077,26.5133702 C51.0203077,38.7034254 51.0203077,50.8934807 51.0203077,63.0835359 C51.0203077,75.2735912 57.8533846,87.4636464 71.5195385,99.6537017 L56.4867692,99.6537017 C44.3390769,89.5578495 38.2652308,77.3677943 38.2652308,63.0835359 C38.2652308,50.8934807 38.2652308,38.7034254 38.2652308,26.5133702 Z",
    id: "Rectangle",
    fill: "#BFE7FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.31107692,0 L74.9948795,0 C79.6340714,-8.52205726e-16 83.3948795,3.7608081 83.3948795,8.4 L83.3948795,45.4151931 C83.3948795,50.054385 79.6340714,53.8151931 74.9948795,53.8151931 L9.31107692,53.8151931 C4.67188502,53.8151931 0.911076923,50.054385 0.911076923,45.4151931 L0.911076923,8.4 C0.911076923,3.7608081 4.67188502,4.40491941e-15 9.31107692,0 Z",
    id: "Rectangle",
    fill: "#BFE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.4241856,0 C9.68636257,-5.99252187e-16 12.3308795,2.64451694 12.3308795,5.90669391 L12.3308795,47.9084992 C12.3308795,51.1706762 9.68636257,53.8151931 6.4241856,53.8151931 C3.16200863,53.8151931 0.517491692,51.1706762 0.517491692,47.9084992 L0.517491692,5.90669391 C0.517491692,2.64451694 3.16200863,5.99252187e-16 6.4241856,0 Z",
    id: "Rectangle",
    fill: "#91D6FF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.0020331,94.1681768 L86.5268899,94.1681768 C90.5663189,94.1681768 93.8409231,97.442781 93.8409231,101.48221 C93.8409231,105.521639 90.5663189,108.796243 86.5268899,108.796243 L31.0020331,108.796243 C26.9626042,108.796243 23.688,105.521639 23.688,101.48221 C23.688,97.442781 26.9626042,94.1681768 31.0020331,94.1681768 Z",
    id: "Rectangle",
    fill: "#91D6FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Wom2.4",
    transform: "translate(292.500000, 293.500000) scale(-1, 1) translate(-292.500000, -293.500000) translate(208.500000, 164.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LLeg",
    transform: "translate(36.000000, 133.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.8908818,93.4149994 C65.8908818,93.4149994 60.6450204,104.010202 64.9454404,107.349009 C69.2523271,110.688463 80.6287118,116.946382 80.6287118,116.946382 L50.4889052,115.052257 L57.1885068,91.9444498 L65.8908818,93.4149994 Z",
    id: "Path",
    fill: "url(#linearGradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4746784,103.00254 C54.4231236,103.455293 52.8637117,107.712416 56.2007118,107.413122 C59.5367975,107.114781 61.631549,102.714356 64.0917865,103.000306 C66.5529383,103.285303 68.1147092,107.716637 72.7993087,110.802986 C77.4829939,113.890289 84.4279679,117.571673 83.9626164,120.675179 C83.4972649,123.778686 72.5683613,124.609846 67.031684,123.582334 C61.4950067,122.555775 58.9104316,120.330133 55.3183568,120.507422 C51.726282,120.684711 49.4690072,120.245302 48.3426554,117.938642 C47.2172179,115.631981 52.3801916,102.480071 53.4746784,103.00254 Z",
    id: "Path",
    fill: "#EEDFE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7411757,117.167073 L54.0483842,117.149485 C58.5001101,116.774046 61.5542762,119.573852 65.7912056,120.363097 C70.0290569,121.153254 81.2049262,121.426384 82.9896728,118.775474 C83.0742349,118.649938 83.1527414,118.521341 83.2256238,118.39065 C83.8250636,119.128483 84.1074632,119.91662 83.9626193,120.835855 C83.4972322,123.789381 72.5674914,124.580375 67.0303901,123.602518 C61.4932887,122.625569 58.9085157,120.507484 55.3161657,120.676205 L54.6776755,120.70015 C51.4543401,120.787711 49.3980991,120.29371 48.33993,118.231564 C48.0823304,117.729149 48.1401075,116.648533 48.3987591,115.283091 C49.9012095,116.311064 51.7976767,117.226371 53.7411757,117.167073 L53.7411757,117.167073 Z",
    id: "Path",
    fill: "#EC7AA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4884247,0.0316169952 C29.6130751,0.439025198 80.3983085,11.6716069 89.6251259,13.5799439 C98.8519433,15.488281 106.65262,25.8144285 99.616745,37.7715359 C91.7143193,51.1940195 71.3246138,89.3135618 66.3741517,97.9066496 C63.9238803,102.159868 51.5626728,99.775193 54.4662646,92.6364873 C59.8790807,79.3286591 62.3927978,45.8981264 76.1929423,33.7088609 C76.1929423,33.7088609 29.7832088,41.7859348 9.73613848,32.5338885 C-4.83355488,25.8084198 -1.53748542,-0.953276169 20.4884247,0.0316169952 Z",
    id: "Path",
    fill: "#413C75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LArm",
    transform: "translate(63.520000, 56.320000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.620558,19.7542764 C56.620558,19.7542764 56.5174491,14.3298511 59.1145031,10.449811 C61.7115571,6.56977099 61.814666,2.4483177 63.7801783,2.5832251 C65.7456906,2.71813249 63.7995112,12.2978488 63.7995112,12.2978488 C63.7995112,12.2978488 66.2934564,11.3451056 68.0849725,10.1399759 C69.8764887,8.93484614 75.3090359,2.9937567 76.5785635,4.0465508 C78.7309606,5.84036735 75.2639258,15.9590677 73.3757451,17.9820332 C71.4811201,20.0056442 62.1315699,25.66 62.1315699,25.66 L34.5969693,53.3991758 L30.48,38.6733768 L56.620558,19.7542764 Z",
    id: "Path",
    fill: "url(#linearGradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.54663565,17.3054119 C5.79120596,27.1502283 13.56312,45.2355076 16.7671239,50.6311677 C20.7824169,57.3883826 27.1139989,60.3654607 34.5272997,55.3519295 C35.5612829,54.6526447 37.5630512,53.0800055 40.5326047,50.6340119 C39.8735337,44.2119674 37.4741133,38.8442735 33.3382109,34.5285872 C31.4658326,36.0776539 30.5296435,36.8521873 30.5296435,36.8521873 C30.5296435,36.8521873 22.5637255,16.4323943 16.1557177,4.60344703 C10.6060302,-5.63055297 -4.91428232,2.33889234 1.54663565,17.3054119 Z",
    id: "Path",
    fill: "#EA5455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6119482,36.8627693 C32.0382744,41.7006022 32.9181507,43.9794623 33.2515771,43.6993494 C33.5850034,43.4192365 33.4576271,40.5081981 32.8694482,34.9662341 L30.6119482,36.8627693 Z",
    id: "Path",
    fillOpacity: 0.159855769,
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Head",
    transform: "translate(35.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7218772,35.4114385 L11.7218772,44.1226204 L5.3248217,38.9719222 C5.3248217,38.9719222 3.35857854,30.6257151 1.75941921,24.4267409 C0.756609818,20.5394549 -1.68668917,7.38357181 8.14940566,8 C16.2069355,-6.20365389 39.6728533,2.58721143 39.8597256,19.9399601 C40.0844849,40.8108431 39.9010636,48.9367847 39.9010636,48.9367847 C26.6315656,49.6983072 19.1627172,47.7798245 11.7218772,35.4114385 Z",
    id: "Path",
    fill: "#422851"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.18659098,51.997375 C5.18659098,51.997375 11.1374613,50.6003429 11.3439066,40.8495617 C11.5503519,31.0987804 11.40543,27.7703624 11.40543,27.7703624 L24.5134378,27.533839 C24.5134378,27.533839 24.6561105,38.4009284 24.6583597,42.3315929 C24.6638284,51.8888195 31.6921775,52.6723672 31.6921775,52.6723672 C31.6921775,52.6723672 30.4907816,60.5575695 18.6133402,61.2254406 C9.33970734,61.7477062 5.18659098,51.997375 5.18659098,51.997375 Z",
    id: "Path",
    fill: "url(#linearGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34980463,22.9012472 C2.50234369,22.6749776 3.45613252,31.2351927 9.53054658,31.2235716 C9.53054658,31.2235716 13.0586589,43.3838644 25.3078124,43.3838644 C35.2557047,43.3838644 35.902832,29.2108175 35.9930663,26.3834737 C36.0901367,23.3688253 36.1024413,13.464919 36.1024413,13.464919 L8.12216791,13.4519308 L8.34980463,22.9012472 Z",
    id: "Path",
    fill: "url(#linearGradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.89727546,22.8450133 C10.3205807,23.2445966 10.0265395,24.8489843 10.6855974,24.7087265 C14.0315837,23.9973471 27.5756504,24.9357728 29.319619,17.4879832 C31.4895477,22.141013 32.0199848,23.2849038 36.7982257,24.533839 L36.7982257,10.8988839 L6.57645026,8 C6.57645026,8 7.04556985,22.7037464 7.89727546,22.8450133 Z",
    id: "Path",
    fill: "#422851"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1629909,34.2395688 C23.1629909,34.2395688 25.174384,37.4906544 29.10285,36.3347801",
    id: "Path",
    stroke: "#F77B7B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    transform: "translate(26.132920, 35.411438) rotate(-18.000000) translate(-26.132920, -35.411438) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8673644,38.1201267 C25.7892466,38.5070311 26.6636527,38.5070311 27.4288074,38.0624194",
    id: "Path",
    stroke: "#F49494",
    strokeLinecap: "round",
    transform: "translate(26.148086, 38.232943) rotate(2.000000) translate(-26.148086, -38.232943) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.61933251,27.6491329 C8.98679677,26.3247221 8.82396936,25.1679422 7.50869093,24.6393988",
    id: "Path-8",
    stroke: "#F77B7B",
    strokeLinecap: "round",
    transform: "translate(8.149406, 26.144266) rotate(-13.000000) translate(-8.149406, -26.144266) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Body",
    transform: "translate(20.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5158423,1 C28.983973,5.57401367 37.6176024,7.25091256 45.6546351,2.28384364 C58.7704103,28.1454421 62.0390104,59.0018184 58.8841907,93.1062883 C39.7587424,100.67799 23.6846772,99.1888952 10,90.534496 L21.5158423,1 Z",
    id: "Path",
    fill: "#FFE4F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "RLeg",
    transform: "translate(2.000000, 79.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.584626,97.840369 C112.584626,97.840369 112.42648,110.31094 122.70222,114.973501 C132.971493,119.635414 140.288019,119.354755 139.3568,122.959348 C138.425581,126.563294 111.695624,126.417793 109.199441,123.598916 C107.071864,121.201028 102.445333,98.8718252 101.171374,100.57906 L112.584626,97.840369 Z",
    id: "Path",
    fill: "url(#linearGradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.12081,115.451758 C106.695528,114.318583 108.019765,120.853164 112.29729,119.035754 C116.574814,117.219286 113.201686,111.213176 115.89361,110.105412 C118.585534,108.997649 123.783778,114.953405 130.687675,116.400932 C137.591572,117.847519 143.197124,119.11433 144.79026,121.801385 C146.162383,124.11103 144.79026,124.849393 144.79026,124.849393 C144.79026,124.849393 138.143796,128.168262 134.013922,128.898801 C128.014416,129.960062 110.674685,130.6668 108.774893,128.731743 C107.608128,127.544921 104.333451,116.019287 105.12081,115.451758 Z",
    id: "Path",
    fill: "#EEDFE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.164844,122.072983 C146.466472,124.195559 144.41258,125.299775 144.166441,125.422338 L143.176088,125.844279 C141.295406,126.62556 137.053938,128.301927 133.919083,128.901185 C128.170932,130 110.371438,130.651092 108.456615,128.76162 C108.1202,128.430106 107.70506,127.21704 107.302343,125.640944 L108.523897,125.774184 C114.401831,126.396594 127.522564,127.523521 133.997847,125.998065 C139.745316,124.644068 142.891763,122.416566 144.326431,121.116514 C144.675418,121.415794 144.957168,121.733643 145.164844,122.072983 Z",
    id: "Path",
    fill: "#EC7AA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.89797632,0.176460422 C-2.94573928,18.853434 -1.15345138,31.3985644 11.27484,37.8118516 C29.3036138,47.1151178 83.2756203,36.1118516 83.2756203,36.1118516 C83.2756203,36.1118516 82.3111872,43.8766427 83.2756203,50.8019006 C85.7944824,68.8889711 97.7739585,99.0229548 100.308519,102.809363 C103.813523,108.045529 114.490464,104.096649 114.691579,99.7367192 C114.892694,95.3767898 106.642757,39.6931486 105.388198,29.0746682 C104.140107,18.455541 100.199739,16.9130742 88.6909289,14.0102649 C86.0469405,13.3433849 54.7801562,5.5730831 51.9158504,5.7995642 C35.5084792,7.09689753 20.1691879,5.22252961 5.89797632,0.176460422 Z",
    id: "Path",
    fill: "#524D87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.44,34.9205711 C38.2890882,36.9205711 85.5438118,32.798013 87.4416672,34.6713084 C89.2535985,36.4597915 88.9512823,67.5753949 93.0158622,85.5848345 L92.3977092,83.8841847 C88.5751277,73.2672348 84.605935,60.3544266 83.2756203,50.8019006 C82.3111872,43.8766427 83.2756203,36.1118516 83.2756203,36.1118516 L81.0994032,36.5330893 C70.8399213,38.4602214 27.1401609,45.9987259 11.27484,37.8118516 C2.67846611,33.3759229 -0.829449593,26.0064085 0.751092899,15.7033083 C3.47270775,27.3487456 10.0356597,33.7547592 20.44,34.9205711 Z",
    id: "Path",
    fillOpacity: 0.0561079545,
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.8425791,1.02073112 C34.2109248,41.5374114 41.6283812,98.9791105 3,88.985834 C23.5197512,51.2055231 -4.37555616,34.2015512 1.94717213,14.6758084 C4.10889898,8 21.6811652,0.496984896 21.8425791,1.02073112 Z",
    id: "Path",
    fill: "#EA5455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.89213813,17.8454787 C21.8715353,19.9550268 10.3478768,44.3624052 14.9622087,48.0393418 C19.5765406,51.7162784 27.6081301,52.11297 28.4741625,54.359368 C30.2147182,58.8741883 21.800869,70.2712827 3.2326149,88.5506511 L3,88.985834 C20.8745494,56.0757843 2.0118623,38.9307734 1.0308512,22.1511913 C3.10193703,18.9026674 5.38916036,17.4677691 7.89213813,17.8454787 Z",
    id: "Path",
    fillOpacity: 0.159855769,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,2 C49.7198862,13.8383269 51.9886728,23.1267812 54.1055316,40.5033862 C55.2823565,50.1514197 55.5762854,64.9302169 54.9873184,84.8397778 L60.8200061,85.9867536 C63.5998226,55.2273917 64.5251361,37.8674287 63.5959466,33.9068646 C61.2562605,23.9379639 59.6712171,18.1134529 56.5820212,9 C54.8804313,3.99804952 45,2 45,2 Z",
    id: "Path",
    fill: "#EA5455"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RArm",
    transform: "translate(0.000000, 59.900000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.44,37.1174069 C44.44,37.1174069 52.0555701,29.49211 54.6929895,28.6072038 C57.3304089,27.7222976 71.7772209,26.6592484 71.6795387,28.6588395 C71.5688322,30.8010741 62.2723573,30.677794 61.412754,31.731807 C60.5531506,32.7851746 59.3577862,40.9883498 56.108225,41.7970934 C52.8651759,42.605837 46.1425409,45 46.1425409,45 L16.2182605,60.4615348 L19.4063845,45.0011933 L44.44,37.1174069 Z",
    id: "Path",
    fill: "url(#linearGradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5191872,4.83146563 C12.442156,17.6421902 4.6924099,37.1560477 1.71768334,44.7639402 C-1.25704322,52.3718328 1.7437185,63.8469539 14.8242849,61.594157 C15.8625771,61.4154829 17.2261817,60.9975127 18.9150988,60.3402465 C23.7247511,53.747166 24.5683306,48.0868079 22.7733472,43.0469746 C21.6455348,43.5230441 21.0816287,43.7610789 21.0816287,43.7610789 C21.0816287,43.7610789 34.0824099,20.7168582 37.2570193,14.5393035 C42.5597927,4.22241094 29.5144997,-6.45603437 21.5191872,4.83146563 Z",
    id: "Path",
    fill: "#EA5455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0816287,43.7610789 C16.6792327,45.9114041 14.7548707,46.513628 15.3085427,45.5677508 C15.8622147,44.6218735 18.6250363,42.5265452 23.5970073,39.2817657 L21.0816287,43.7610789 Z",
    id: "Path",
    fillOpacity: 0.159855769,
    fill: "#000000"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Table1",
    transform: "translate(79.500000, 284.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(26.475884, 4.554930)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#DBDBDB",
    points: "79.6619936 -1.13686838e-13 91.6619936 -1.13686838e-13 91.6619936 147.579718 79.6619936 147.579718"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#EFEFEF",
    points: "77.6619936 -1.13686838e-13 85.6619936 -1.13686838e-13 85.6619936 147.579718 77.6619936 147.579718"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#DBDBDB",
    points: "2.49864952 -1.13686838e-13 14.4986495 -1.13686838e-13 14.4986495 147.579718 2.49864952 147.579718"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#EFEFEF",
    points: "0.498649518 -1.13686838e-13 8.49864952 -1.13686838e-13 8.49864952 147.579718 0.498649518 147.579718"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-25"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#DBDBDB",
    points: "310.633312 4.55492958 322.633312 4.55492958 322.633312 152.134648 310.633312 152.134648"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#EFEFEF",
    points: "308.633312 4.55492958 316.633312 4.55492958 316.633312 152.134648 308.633312 152.134648"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#DBDBDB",
    points: "228.469968 4.55492958 240.469968 4.55492958 240.469968 152.134648 228.469968 152.134648"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#EFEFEF",
    points: "226.469968 4.55492958 234.469968 4.55492958 234.469968 152.134648 226.469968 152.134648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.448489,0 L324.451961,0 C325.3798,-1.58280756e-14 326.131961,0.75216162 326.131961,1.68 L326.131961,17.32 C326.131961,18.2478384 325.3798,19 324.451961,19 L111.448489,19 C110.52065,19 109.768489,18.2478384 109.768489,17.32 L109.768489,1.68 C109.768489,0.75216162 110.52065,1.70441145e-16 111.448489,0 Z",
    id: "Rectangle",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1558842,0 L232.246431,0 C233.174269,-1.70441145e-16 233.926431,0.75216162 233.926431,1.68 L233.926431,17.32 C233.926431,18.2478384 233.174269,19 232.246431,19 L20.1558842,19 C19.2280459,19 18.4758842,18.2478384 18.4758842,17.32 L18.4758842,1.68 C18.4758842,0.75216162 19.2280459,-5.16034596e-17 20.1558842,0 Z",
    id: "Rectangle",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EFEFEF",
    x: 0,
    y: 0,
    width: 338,
    height: 9.76056338
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Pot5",
    transform: "translate(140.500000, 238.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-33",
    transform: "translate(0.698880, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6555829,14.4692915 L14.6555829,10.2808124 L19.9389996,10.2805325 L19.9391157,8.05964919 C19.9391157,6.83293465 20.9247483,5.83848603 22.1405877,5.83848603 C23.3564271,5.83848603 24.3420597,6.83293465 24.3420597,8.05964919 L24.3420597,12.6923609 C24.3420597,13.6737326 23.5535537,14.4692915 22.5808821,14.4692915 L14.6555829,14.4692915 Z",
    id: "Path",
    fill: "#02B596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.69482223e-13,16.88084 L3.69482223e-13,12.8827463 C3.69482223e-13,11.6560318 0.985632587,10.6615832 2.201472,10.6615832 C3.41731141,10.6615832 4.402944,11.6560318 4.402944,12.8827463 L4.40266667,15.1033953 L7.04383333,15.1033953 L7.0447104,4.88655896 C7.0447104,2.18778697 9.21310209,1.51444748e-13 11.8879488,1.51444748e-13 C14.5627955,1.51444748e-13 16.7311872,2.18778697 16.7311872,4.88655896 L16.7311872,30.207819 L7.0447104,30.207819 L7.04383333,19.5454419 L2.6417664,19.5462358 C1.1827591,19.5462358 3.69482223e-13,18.3528975 3.69482223e-13,16.88084 Z",
    id: "Path",
    fill: "#02D3AF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-34",
    transform: "translate(0.000000, 23.269328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.118208,0 L23.482368,0 L21.8826493,21.5203661 C21.8388877,22.109073 21.3526996,22.5641972 20.7675731,22.5641972 L3.83300295,22.5641972 C3.24787637,22.5641972 2.76168829,22.109073 2.7179267,21.5203661 L1.118208,0 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.118208,0 L23.482368,0 C24.0999372,0 24.600576,0.50511676 24.600576,1.12820986 L24.600576,5.6410493 C24.600576,6.2641424 24.0999372,6.76925916 23.482368,6.76925916 L1.118208,6.76925916 C0.500638774,6.76925916 0,6.2641424 0,5.6410493 L0,1.12820986 C0,0.50511676 0.500638774,0 1.118208,0 Z",
    id: "Rectangle",
    fill: "#FFB3A4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "FacingBack-Laptop3",
    transform: "translate(208.500000, 236.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.18087287,45.5196672 L112.437047,45.5196672 C113.269618,45.5196672 113.94455,46.1945994 113.94455,47.0271705 C113.94455,47.8597415 113.269618,48.5346737 112.437047,48.5346737 L7.18087287,48.5346737 C6.3483018,48.5346737 5.6733696,47.8597415 5.6733696,47.0271705 C5.6733696,46.1945994 6.3483018,45.5196672 7.18087287,45.5196672 Z",
    id: "Rectangle",
    fill: "#8F84FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5032336,45.5196672 L112.437047,45.5196672 C113.269618,45.5196672 113.94455,46.1945994 113.94455,47.0271705 C113.94455,47.8597415 113.269618,48.5346737 112.437047,48.5346737 L78.5032336,48.5346737 C77.6706625,48.5346737 76.9957303,47.8597415 76.9957303,47.0271705 C76.9957303,46.1945994 77.6706625,45.5196672 78.5032336,45.5196672 Z",
    id: "Rectangle",
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.08948722,0 L70.3577685,0 C72.1695107,-1.66507926e-15 73.6989826,1.34640321 73.9287106,3.14352164 L78.8437908,41.593245 C79.0958968,43.5654219 77.7015039,45.3685595 75.729327,45.6206655 C75.5779374,45.6400178 75.4254702,45.6497234 75.2728487,45.6497234 L9.00456736,45.6497234 C7.1928252,45.6497234 5.66335333,44.3033202 5.43362525,42.5062018 L0.518545114,4.05647836 C0.266439078,2.08430149 1.66083199,0.281163932 3.63300886,0.0290578962 C3.78439853,0.00970555035 3.93686564,9.16214548e-16 4.08948722,0 Z",
    id: "Rectangle",
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.08948722,0 L68.0235822,0 C69.8353243,-7.65759119e-15 71.3647962,1.34640321 71.5945243,3.14352164 L76.5096044,41.593245 C76.7617105,43.5654219 75.3673175,45.3685595 73.3951407,45.6206655 C73.243751,45.6400178 73.0912839,45.6497234 72.9386623,45.6497234 L9.00456736,45.6497234 C7.1928252,45.6497234 5.66335333,44.3033202 5.43362525,42.5062018 L0.518545114,4.05647836 C0.266439078,2.08430149 1.66083199,0.281163932 3.63300886,0.0290578962 C3.78439853,0.00970555035 3.93686564,2.24848218e-15 4.08948722,0 Z",
    id: "Rectangle",
    fill: "#B1A9FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    transform: "translate(37.315147, 23.551241) rotate(-37.000000) translate(-37.315147, -23.551241) ",
    cx: 37.315147,
    cy: 23.5512408,
    rx: 4.64830581,
    ry: 5.07495986
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(335.500000, 273.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,0 L46.5,0 C49.5375661,-5.57991845e-16 52,2.46243388 52,5.5 C52,8.53756612 49.5375661,11 46.5,11 L1,11 C0.44771525,11 6.76353751e-17,10.5522847 0,10 L0,1 C-6.76353751e-17,0.44771525 0.44771525,1.01453063e-16 1,0 Z",
    id: "Rectangle",
    fill: "#F16B79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,2.2 L27.0333333,2.2 C28.855873,2.2 30.3333333,3.67746033 30.3333333,5.5 C30.3333333,7.32253967 28.855873,8.8 27.0333333,8.8 L1,8.8 C0.44771525,8.8 6.76353751e-17,8.35228475 0,7.8 L0,3.2 C-6.76353751e-17,2.64771525 0.44771525,2.2 1,2.2 Z",
    id: "Rectangle",
    fill: "#EAEFFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-73",
    transform: "translate(500.000000, 337.500000) scale(-1, 1) translate(-500.000000, -337.500000) translate(429.500000, 238.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#91D6FF",
    x: 0,
    y: 0,
    width: 131.195077,
    height: 198.347541
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#BFE7FF",
    x: 35.4018462,
    y: 0,
    width: 95.7932308,
    height: 198.347541
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4116923,133.623607 L115.185231,133.623607 C119.426778,133.623607 122.865231,137.06206 122.865231,141.303607 L122.865231,182.316066 C122.865231,186.557612 119.426778,189.996066 115.185231,189.996066 L51.4116923,189.996066 C47.1701454,189.996066 43.7316923,186.557612 43.7316923,182.316066 L43.7316923,141.303607 C43.7316923,137.06206 47.1701454,133.623607 51.4116923,133.623607 Z",
    id: "Rectangle",
    fill: "#E3F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8036923,133.623607 L95.7932308,133.623607 L95.7932308,140.222951 C95.7932308,142.343724 94.0740042,144.062951 91.9532308,144.062951 L74.6436923,144.062951 C72.5229189,144.062951 70.8036923,142.343724 70.8036923,140.222951 L70.8036923,133.623607 L70.8036923,133.623607 Z",
    id: "Rectangle",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7316923,19.2257923 L115.185231,19.2257923 C119.426778,19.2257923 122.865231,22.6642455 122.865231,26.9057923 L122.865231,57.0439344 C122.865231,61.2854813 119.426778,64.7239344 115.185231,64.7239344 L45.7316923,64.7239344 C44.6271228,64.7239344 43.7316923,63.8285039 43.7316923,62.7239344 L43.7316923,21.2257923 C43.7316923,20.1212229 44.6271228,19.2257923 45.7316923,19.2257923 Z",
    id: "Rectangle",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7655385,8.35147541 L132.539077,8.35147541 C136.780624,8.35147541 140.219077,11.7899285 140.219077,16.0314754 L140.219077,57.0439344 C140.219077,61.2854813 136.780624,64.7239344 132.539077,64.7239344 L68.7655385,64.7239344 C64.5239916,64.7239344 61.0855385,61.2854813 61.0855385,57.0439344 L61.0855385,16.0314754 C61.0855385,11.7899285 64.5239916,8.35147541 68.7655385,8.35147541 Z",
    id: "Rectangle",
    fill: "#E3F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4116923,70.987541 L115.185231,70.987541 C119.426778,70.987541 122.865231,74.4259941 122.865231,78.667541 L122.865231,119.68 C122.865231,123.921547 119.426778,127.36 115.185231,127.36 L51.4116923,127.36 C47.1701454,127.36 43.7316923,123.921547 43.7316923,119.68 L43.7316923,78.667541 C43.7316923,74.4259941 47.1701454,70.987541 51.4116923,70.987541 Z",
    id: "Rectangle",
    fill: "#E3F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8036923,70.987541 L95.7932308,70.987541 L95.7932308,77.5868852 C95.7932308,79.7076587 94.0740042,81.4268852 91.9532308,81.4268852 L74.6436923,81.4268852 C72.5229189,81.4268852 70.8036923,79.7076587 70.8036923,77.5868852 L70.8036923,70.987541 L70.8036923,70.987541 Z",
    id: "Rectangle",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1575385,8.35147541 L113.147077,8.35147541 L113.147077,14.9508197 C113.147077,17.0715931 111.42785,18.7908197 109.307077,18.7908197 L91.9975385,18.7908197 C89.876765,18.7908197 88.1575385,17.0715931 88.1575385,14.9508197 L88.1575385,8.35147541 L88.1575385,8.35147541 Z",
    id: "Rectangle",
    fill: "#91D6FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Table-Frame2",
    transform: "translate(480.500000, 196.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#7367F0",
    points: "29.3617629 20.6769231 36.4017629 20.6769231 44 41.3538462 36.96 41.3538462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2076745,0 L43.0118493,0 C43.4536771,3.62101212e-15 43.8118493,0.3581722 43.8118493,0.8 C43.8118493,0.855963301 43.8059771,0.911772134 43.794329,0.966509817 L35.3348052,40.720356 C35.2562006,41.0897424 34.9299828,41.3538462 34.5523255,41.3538462 L2.74815069,41.3538462 C2.30632289,41.3538462 1.94815069,40.995674 1.94815069,40.5538462 C1.94815069,40.4978829 1.95402294,40.442074 1.96567099,40.3873363 L10.4251948,0.633490183 C10.5037994,0.264103752 10.8300172,1.80396817e-16 11.2076745,0 Z",
    id: "Rectangle",
    fill: "#A7C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.4476745,0 L41.2518493,0 C41.6936771,3.62101212e-15 42.0518493,0.3581722 42.0518493,0.8 C42.0518493,0.855963301 42.0459771,0.911772134 42.034329,0.966509817 L33.5748052,40.720356 C33.4962006,41.0897424 33.1699828,41.3538462 32.7923255,41.3538462 L0.988150688,41.3538462 C0.546322888,41.3538462 0.188150688,40.995674 0.188150688,40.5538462 C0.188150688,40.4978829 0.194022939,40.442074 0.205670988,40.3873363 L8.6651948,0.633490183 C8.74379935,0.264103752 9.07001723,1.80396817e-16 9.4476745,0 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-17)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-93",
    transform: "translate(2.200000, 1.723077)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-19",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-18"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    fill: "#B3FFEB",
    fillRule: "nonzero",
    xlinkHref: "#path-18"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-92",
    mask: "url(#mask-19)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12.100000, 6.892308)",
    id: "Oval"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 29.15,
    cy: 3.76923077,
    rx: 3.85,
    ry: 3.76923077
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#6DE9C9",
    cx: 17.875,
    cy: 32.0384615,
    rx: 17.875,
    ry: 17.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#83F2D5",
    cx: 45.925,
    cy: 26.9230769,
    rx: 21.175,
    ry: 20.4615385
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Wom1.2",
    transform: "translate(74.500000, 239.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Head",
    transform: "translate(30.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.61629772,54.292968 C-2.10718861,51.5797984 -2.87928334,35.5880573 6.03377818,30.0407917 C-3.15817331,10.891759 18.0982964,-8.12074103 32.6587863,3.60457519 C42.2043104,-0.455953086 50.1367648,15.3890618 41.2545871,27.6953118 C44.9787241,48.8255015 37.3993544,54.2874435 23.7363661,54.5194747 L9.61629772,54.292968 Z",
    id: "Path",
    fill: "#422851"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.76214969,50.4736905 C9.76214969,50.4736905 15.465067,49.1431837 15.6629105,39.8567254 C15.8607539,30.5702671 15.7218704,27.4003452 15.7218704,27.4003452 L28.2837112,27.1750848 C28.2837112,27.1750848 28.4206434,37.5246936 28.4225947,41.2681837 C28.4278356,51.3226852 35.4774854,50.4736905 35.4774854,50.4736905 C35.4774854,50.4736905 34.011999,58.6262566 22.629451,59.2623244 C13.7422195,59.7597202 9.76214969,50.4736905 9.76214969,50.4736905 Z",
    id: "Path",
    fill: "url(#linearGradient-20)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7935628,22.7630925 C7.18974604,22.5475977 8.10379366,30.7001835 13.9251071,30.6891158 C13.9251071,30.6891158 17.3062148,42.270347 29.0449869,42.270347 C38.5783836,42.270347 39.1985473,28.7722071 39.2850219,26.0794988 C39.3780476,23.208405 39.3898396,13.7761134 39.3898396,13.7761134 L12.5754109,13.7637436 L12.7935628,22.7630925 Z",
    id: "Path",
    fill: "url(#linearGradient-21)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9887377,33.55577 C26.9887377,33.55577 28.9208668,36.6574086 32.6813917,35.5627912",
    id: "Path",
    stroke: "#F77B7B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    transform: "translate(29.835065, 34.676261) rotate(-18.000000) translate(-29.835065, -34.676261) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6229283,37.2575297 C29.5063117,37.6258215 30.3442779,37.6256399 31.0776378,37.2020382",
    id: "Path",
    stroke: "#F49494",
    strokeLinecap: "round",
    transform: "translate(29.850283, 37.364575) rotate(2.000000) translate(-29.850283, -37.364575) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0536757,27.2861215 C13.4039904,26.0248583 13.2464873,24.9226023 11.9857187,24.4173524",
    id: "Path-8",
    stroke: "#F77B7B",
    strokeLinecap: "round",
    transform: "translate(12.600780, 25.851737) rotate(-13.000000) translate(-12.600780, -25.851737) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.906939,21.7558029 C11.906939,21.7558029 14.9784654,25.8516818 15.6006402,25.8734368 C16.2228149,25.8951918 16.4406792,20.5465395 16.4406792,20.5465395 C20.2085015,20.2604904 29.7440793,18.3734243 32.0815402,13.97725 C33.7161942,17.8561814 36.8410129,19.5791288 38.8941297,19.2482694 L39.2832655,27.4890618 L40.2415988,10.9215669 L11.1556667,10.9215669 L11.906939,21.7558029 Z",
    id: "Path",
    fill: "#422851"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LArm",
    transform: "translate(61.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(52.849275, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.20251955,27.3289525 C1.20251955,27.3289525 -0.47123099,17.9880624 0.130566956,16.0965306 C0.6446027,14.461765 5.50286736,12.1044128 5.50286736,12.1044128 C5.50286736,12.1044128 13.9531135,-1.26375123 15.8023884,0.097297877 C17.3068833,1.20095301 11.401741,11.056631 11.401741,11.056631 C11.401741,11.056631 16.7865788,16.7142761 16.7113541,19.243015 C16.6361293,21.7723816 7.9225966,29.6894435 7.9225966,29.6894435 L1.20251955,27.3289525 Z",
    id: "Path",
    fill: "url(#linearGradient-22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.68466049,11.9700657 C5.68466049,11.9700657 9.42709146,11.4603001 10.0226207,12.6267343 C10.5303877,13.6205261 7.42109831,16.4392572 7.42109831,17.2315752 C7.42109831,18.0238933 7.46554157,24.0212484 7.71572856,24.0757437 C7.96591555,24.130239 11.4644283,14.2891227 10.7184496,12.2073704 C10.1041142,10.4985256 5.68466049,11.9700657 5.68466049,11.9700657 Z",
    id: "Path",
    fill: "#F28585"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.55009,26.2240417 C3.93330917,23.8886623 -2.86826135,30.5922058 1.27536825,36.9912711 C7.89514565,47.2229954 32.3325493,74.0883439 43.5974546,74.1279407 C53.7151826,74.163051 63.0098075,33.918866 62.7966707,30.7114859 C62.5835339,27.5034781 54.3714995,23.4900155 51.3875846,25.7557103 C48.3974011,28.021405 38.9378897,54.5687683 38.9378897,54.5687683 C38.9378897,54.5687683 15.254633,28.5983442 9.55009,26.2240417 Z",
    id: "Path",
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9378897,54.5687683 C41.0690558,58.2374647 42.2329497,59.7975233 42.4295715,59.2489441 C42.6261933,58.7003649 41.8488709,56.0617627 40.0976044,51.3331377 L38.9378897,54.5687683 Z",
    id: "Path",
    fillOpacity: 0.302802666,
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LLeg",
    transform: "translate(38.000000, 123.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3464375,187.709033 C25.3464375,187.709033 24.2265,196.914586 28.4030625,200.430519 C32.579625,203.94583 16.467375,202.676912 16.467375,202.676912 L16.3498125,187.56238 L25.3464375,187.709033 Z",
    id: "Path",
    fill: "url(#linearGradient-23)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.313625,195.867813 C17.749125,195.944868 17.5201875,200.259932 19.4445,200.079724 C21.3688125,199.898894 24.6225,195.59782 27.4130625,197.044461 C30.3088125,198.548892 46.1806875,208.601728 47.115,211.185546 C48.1606875,214.065777 41.3915625,214.280785 36.5529375,214.070749 C31.708125,213.860091 29.4744375,211.679567 27.1231875,211.733629 C24.76575,211.788313 24.208875,213.257324 22.4454375,213.661862 C20.65725,214.073234 16.1836875,214.011093 15.769125,212.724155 C15.336,211.387504 14.8843125,195.790137 16.313625,195.867813 Z",
    id: "Path",
    fill: "#222D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.02318154e-14,6.85052413e-14 C-1.02318154e-14,6.85052413e-14 9.6301875,92.7193077 10.416,101.191173 C11.2018125,109.663038 9.6301875,115.797374 8.98575,124.547736 C8.3413125,133.298098 11.443125,188.331684 11.443125,188.331684 C16.0033125,191.086391 21.42975,191.627017 28.3288125,188.414953 C28.3288125,188.414953 34.6648125,119.856135 34.6029375,104.240747 C34.5658125,94.9258255 35.5310625,1.04583144 35.5310625,1.04583144 L-1.02318154e-14,6.85052413e-14 Z",
    id: "Path",
    fill: "#2B256A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3878116,101.952365 C16.1788009,107.817551 14.0539607,118.927704 9.01329111,135.282824 L8.94979371,132.593677 C8.8777767,129.037977 8.87557641,126.265152 8.97351479,124.72643 L8.98575,124.547736 C9.60870625,116.089053 11.0980677,110.0749 10.4868448,102.030751 L10.3546246,100.544103 C10.0244195,97.1157619 8.99812264,87.0584843 7.71218434,74.5530034 L8.41780228,76.596495 C12.3232273,88.0025146 14.6463612,96.4545105 15.3878116,101.952365 Z",
    id: "Path",
    fillOpacity: 0.0771689248,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0943827,198.068388 L28.44706,199.055986 C28.1443032,199.517892 28.2733187,200.137773 28.7352242,200.44053 C28.7482367,200.449059 28.7614464,200.457283 28.7748425,200.465196 L38.340963,206.115537 C38.6343253,206.288815 38.995726,206.300803 39.2999268,206.147348 L40.5767978,205.503224 L40.5767978,205.503224 C36.8566712,202.797229 33.1300003,200.376317 29.0943827,198.068388 Z",
    id: "Path-14",
    fillOpacity: 0.54097465,
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RLeg",
    transform: "translate(9.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-24)",
    points: "13.4593149 192.203698 14.2680192 206.233498 3.90079485 206.508374 5.84938673 192.203698"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.80350712,201.367438 C11.1507986,206.908274 13.9700755,199.975407 14.5963653,200.662596 C15.7881401,201.970112 18.0439995,214.990516 16.8157418,216.815591 C15.7334157,218.432033 1.00040423,218.459272 0.185619439,216.936932 C-0.884545655,214.921178 2.98638275,200.751218 3.80350712,201.367438 Z",
    id: "Path",
    fill: "#222D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.0641315,204.967266 L10.1384864,204.967266 C10.6284199,204.967266 11.0462059,205.322223 11.1253518,205.805721 L11.7413594,209.568879 C11.8305778,210.11391 11.461069,210.628071 10.9160382,210.717289 C10.8626342,210.726031 10.8086087,210.730424 10.7544939,210.730424 L7.44812392,210.730424 C6.89583917,210.730424 6.44812392,210.282708 6.44812392,209.730424 C6.44812392,209.676309 6.45251652,209.622283 6.46125845,209.568879 L7.07726604,205.805721 C7.15641199,205.322223 7.57419795,204.967266 8.0641315,204.967266 Z",
    id: "Rectangle",
    fillOpacity: 0.54097465,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0908007,4.09496998e-14 C23.0908007,4.09496998e-14 12.7658646,9.30484988 10.0551654,22.6729048 C5.53644491,44.9573779 7.81054574,86.1153302 7.6767751,95.140413 C7.54908495,104.165496 4.30375187,109.610946 2.56308848,122.371672 C0.822425096,135.132397 2.54484703,192.1619 2.54484703,192.1619 C7.159934,194.946564 12.1641719,195.145911 17.6670095,191.994746 L49.9847792,2.97659976 L23.0908007,4.09496998e-14 Z",
    id: "Path",
    fill: "#38308B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2125557,8.30473344 L20.2460344,8.85997019 C16.7022804,15.6385366 14.9119463,31.0967427 14.8750322,55.2345886 L14.8744493,55.9997215 C14.8744493,92.4959446 8.28611334,105.35255 5.63552834,121.064047 L5.55642374,121.541054 C3.96877574,131.284466 2.77952074,146.897529 1.98865873,168.380244 L1.90825528,163.05424 C1.68819925,146.824351 1.68332654,128.821167 2.56308848,122.371672 C4.30375187,109.610946 7.54908495,104.165496 7.6767751,95.140413 L7.68256162,94.242774 C7.68021323,83.6628392 5.67200653,44.2888437 10.0551654,22.6729048 C11.1999744,17.0271775 13.702877,12.1061732 16.2125557,8.30473344 Z",
    id: "Path",
    fillOpacity: 0.0771689248,
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Body",
    transform: "translate(21.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,9.70312373 C0,9.70312373 9.88775391,42.8366538 10.1805859,49.1085804 C10.473418,55.3811305 2.0934375,73.8159432 3.52021484,78.4754628 C6.80990234,89.2429248 48.8094922,93.8793744 53.3141211,79.3945223 C55.2393359,73.2092642 51.5384375,66.576323 53.3328125,58.6165442 C55.120957,50.6567655 60.3752142,38.828423 56.2985156,27.7077119 C52.2218171,16.5870007 53.3141211,6.2986138 50.3982617,4.35399775 C47.4824023,2.4093817 40.6662695,0.344179687 40.6662695,0.344179687 C37.3516602,5.22567022 26.1617383,5.15458963 20.8222266,-5.49898291e-14 C20.8222266,-5.49898291e-14 7.55755859,2.57511252 0,9.70312373 Z",
    id: "Path",
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.86064871,15.0694531 C15.4515835,25.5369865 15.4317683,43.7619439 18.9715749,46.1487873 C22.5113816,48.5356307 36.2886447,46.1933418 36.2886447,48.0835699 C36.2886447,49.973798 17.2493337,67.2966677 20.3749054,75.57781 C22.0115126,79.9139697 21.5675716,83.7931962 19.0430822,87.2154895 L18.2190503,87.035787 C10.7174069,85.3391684 4.68642071,82.2925662 3.52021484,78.4754628 C2.0934375,73.8159432 10.473418,55.3811305 10.1805859,49.1085804 C9.93281156,43.8017064 2.81566491,19.2635811 0.631320131,11.8379297 C2.56167086,8.34493447 5.30471654,9.4220237 8.86064871,15.0694531 Z",
    id: "Path",
    fillOpacity: 0.0564903846,
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RArm",
    transform: "translate(0.000000, 54.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.7171668,63.0388937 C50.7171668,63.0388937 57.1510235,60.1868928 59.2333552,60.1950337 C61.315687,60.202582 62.9084229,60.2709872 62.9084229,60.2709872 L62.9146203,63.1546708 C62.9146203,63.1546708 73.4864727,64.1158037 74.6020076,64.0781495 C75.7237399,64.0411228 70.5241079,71.861899 67.022568,73.2783242 C63.1553805,74.8422284 50.0106614,70.2032317 50.0106614,70.2032317 L50.7171668,63.0388937 Z",
    id: "Path",
    fill: "url(#linearGradient-25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5645226,2.76143226 C13.4583027,8.67502344 -7.23486892,59.4171878 2.59423265,66.5338305 C10.9731389,72.6024314 46.5710956,73.3937971 49.2049974,71.4577439 C51.3988826,69.8411239 52.6321683,64.922231 50.5684289,62.2349767 C47.829171,58.6515525 16.9412504,53.4766111 16.9412504,53.4766111 C16.9412504,53.4766111 28.0470196,26.9084394 30.3648531,22.2512431 C38.3161377,6.26578259 33.0483342,-5.61411564 21.5645226,2.76143226 Z",
    id: "Path",
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9846323,53.4452326 C14.6278172,57.1371945 13.6920074,59.0291086 14.1772029,59.1209748 C14.6623984,59.212841 16.4865045,57.4891157 19.6495211,53.9497988 L16.9846323,53.4452326 Z",
    id: "Path",
    fillOpacity: 0.302802666,
    fill: "#000000"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegister);
export default __webpack_public_path__ + "static/media/register.24c0a62e6ffc4b3ea130f253a30a6ea4.svg";
export { ForwardRef as ReactComponent };